import TournamentModel from "../../../models/TournamentModel";
import { prepare as prepareMatch } from '../../../model-preparing/match'
export default {
  SET_TOURNAMENT (state, tournament) {
    state.tournament = new TournamentModel(tournament.data)
  },
  SET_RESULTS (state, value) {
    state.results = value.data
  },
  SET_MATCHES (state, value) {
    state.matches = prepareMatch(state, value)
  },
}
